<script>
import CountdownTimerConnected from '@/launcher/components/connected/ui/CountdownTimerConnected.vue';
import LanguageButtonConnected from '@/launcher/components/connected/ui/LanguageButtonConnected.vue';
import HelpRequestedNotification from '@/launcher/components/shared/notifications/HelpRequestedNotification';
import CallHelpBtnConnected from '../connected/ui/CallHelpBtnConnected';

export default {
  name: 'SettingsBox',
  components: {
    CountdownTimerConnected,
    LanguageButtonConnected,
    HelpRequestedNotification,
    CallHelpBtnConnected,
  },
  props: {
    station: {
      type: Object,
      required: true,
    },
    hasCalledHelp: {
      type: Boolean,
      required: true,
    },
    timerStatus: {
      validator (val) { return typeof val === 'string' || val === null; },
      required: true,
    },
    shouldShowLanguageBtn: { default: true },
  },
  methods: {
    launchTutorial () {
      this.$gtm.trackEvent({
        category: 'Tutorial',
        action: 'launch',
        label: '',
      });
      this.$emit('launch-tutorial');
    },
  },
  computed: {
    isInLanguageRoute () {
      return this.$route.meta.realName === 'language';
    },
  },

};
</script>

<template lang="pug">
  div.settings-box.center.relative.flex
    LanguageButtonConnected.languagebtn._collision.mr3(v-show="shouldShowLanguageBtn && !isInLanguageRoute")
    div.timeremaining.white.tc.mr3.bg-black-overlay(v-if="timerStatus !== 'infinite'")
      CountdownTimerConnected.h-100
    div.buttons.relative
      CallHelpBtnConnected.helpbtn.w-100.h-100.flex.f6(:light="true" style="min-width:20rem")
      .helprequested.absolute.w-100
        HelpRequestedNotification(v-show="hasCalledHelp")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.settings-box {
  /* width: 156px; */
  & .helprequested {
    bottom: -4rem;
  }
  & .languagebtn {
    width: 7rem;
    height: 7rem;
  }
}
</style>
